﻿import { Component, HostBinding, Input, Output, EventEmitter, OnInit, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Ng2SmartTableModule, LocalDataSource, ViewCell } from 'ng2-smart-table';

@Component({
    selector: 'button-view',
    template: `
    <button (click)="onClick()"><i class="fa fa-plus"></i></button>
  `,
})
export class ButtonViewComponent implements ViewCell, OnInit {
    renderValue: string;

    @Input() value: string | number;
    @Input() rowData: any;

    @Output() save: EventEmitter<any> = new EventEmitter();

    ngOnInit() {
        this.renderValue = this.value.toString().toUpperCase();
    }

    onClick() {
        this.save.emit(this.rowData);
    }
}